
/**
 * Fixes avatar image aspect ratios in the cloned document
 */
export const fixAvatarImagesInDocument = (clonedDoc: Document): void => {
  const avatarImages = clonedDoc.querySelectorAll('.avatar-image, .h-24.w-24.rounded-full img, .rounded-full img');
  avatarImages.forEach(img => {
    if (img instanceof HTMLElement) {
      img.style.objectFit = 'cover';
    }
  });
};
